import { render, staticRenderFns } from "./WebinarSales.vue?vue&type=template&id=1f4c501c&scoped=true"
import script from "./WebinarSales.vue?vue&type=script&lang=js"
export * from "./WebinarSales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4c501c",
  null
  
)

export default component.exports